import React from 'react';
import { useState } from 'react';
import { UseAppSelector } from '../../../store/hooks';

import '../../../styles/mobile/calculators/businessStatsDashboardMobile.css';

function BusinessStatsDashboardMobile() {
    // UI states
    const [dashboardState, setDashboardState] = useState('performance');
    const [infoBarState, setInfoBarState] = useState('performance');

    // redux
    const statsEngine = UseAppSelector((state) => state.stats);
    const selectedDashboard = statsEngine.find(item => item.category === dashboardState);
    const selectedInfoBar = statsEngine.find(item => item.category === infoBarState);

    return (
        <section className="mobile-stats-dashboard-section">
            <div className="stats-title">
                <h2>- Stats Dashboard -</h2>
            </div>

            <div className="parent">

                <div className="topBar">
                    <div className="mobile-stats-filter">

                        <input type="radio" value="performance" onClick={e => {setDashboardState(e.target.value); setInfoBarState(e.target.value)}} name="filter-opt-a" id="opt-1a" defaultChecked></input>
                        <label htmlFor="opt-1a">
                            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" className="bi bi-bar-chart" viewBox="0 0 16 16">
                                <path d="M4 11H2v3h2v-3zm5-4H7v7h2V7zm5-5v12h-2V2h2zm-2-1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1h-2zM6 7a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7zm-5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-3z"/>
                            </svg>
                        </label>

                        <input type="radio" value="costs" onClick={e => {setDashboardState(e.target.value); setInfoBarState(e.target.value)}} name="filter-opt-a" id="opt-2a"></input>
                        <label htmlFor="opt-2a">
                            <svg className="svg" xmlns="http://www.w3.org/2000/svg" width="35" height="35" className="bi bi-currency-dollar" viewBox="0 0 16 16">
                                <path d="M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718H4zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73l.348.086z"/>
                            </svg>
                        </label>

                        <input type="radio" value="sales-supply" onClick={e => {setDashboardState(e.target.value); setInfoBarState(e.target.value)}} name="filter-opt-a" id="opt-3a"></input>
                        <label htmlFor="opt-3a">
                            <svg className="svg" xmlns="http://www.w3.org/2000/svg" width="35" height="35" className="bi bi-box-seam" viewBox="0 0 16 16">
                                <path d="M8.186 1.113a.5.5 0 0 0-.372 0L1.846 3.5l2.404.961L10.404 2l-2.218-.887zm3.564 1.426L5.596 5 8 5.961 14.154 3.5l-2.404-.961zm3.25 1.7-6.5 2.6v7.922l6.5-2.6V4.24zM7.5 14.762V6.838L1 4.239v7.923l6.5 2.6zM7.443.184a1.5 1.5 0 0 1 1.114 0l7.129 2.852A.5.5 0 0 1 16 3.5v8.662a1 1 0 0 1-.629.928l-7.185 2.874a.5.5 0 0 1-.372 0L.63 13.09a1 1 0 0 1-.63-.928V3.5a.5.5 0 0 1 .314-.464L7.443.184z"/>
                            </svg>
                        </label>

                        <input type="radio" value="business-modifiers" onClick={e => setInfoBarState(e.target.value)} name="filter-opt-a" id="modifiers"></input>
                        <label className="modifiers" htmlFor="modifiers">
                            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" className="bi bi-arrow-bar-down" viewBox="0 0 16 16">
                                <path fillRule="evenodd" d="M1 3.5a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 0 1h-13a.5.5 0 0 1-.5-.5zM8 6a.5.5 0 0 1 .5.5v5.793l2.146-2.147a.5.5 0 0 1 .708.708l-3 3a.5.5 0 0 1-.708 0l-3-3a.5.5 0 0 1 .708-.708L7.5 12.293V6.5A.5.5 0 0 1 8 6z"/>
                            </svg>
                        </label>

                    </div>

                    <div className="sub-component">
                        {selectedInfoBar.sub_component}
                    </div>

                    <div className="component">
                        {selectedDashboard.component}
                    </div>

                </div>
            </div>
        </section>
    )
}

export default BusinessStatsDashboardMobile;
